import React from "react";
import Playlists from "./Playlists";
type PlaylistsProps = React.ComponentProps<typeof Playlists>;

const MemoizedPlaylists: React.FC<PlaylistsProps> = (props) => (
  <Playlists {...props} />
);

export default React.memo(MemoizedPlaylists);
